import api from '@pray/shared/utils/api';

export async function getPrayTvExpandedSlots({
  artistId,
  startDate,
  endDate,
  all = false,
}: {
  artistId: string;
  startDate: string;
  endDate: string;
  all?: boolean;
}) {
  if (!artistId) throw Error('Artist ID is required');
  if (!startDate) throw Error('Start Date is required');
  if (!endDate) throw Error('End Date is required');

  const url = `/web/studio/artists/${artistId}/pray-tv/expanded-slots`;
  const params = new URLSearchParams({ start_date: startDate, end_date: endDate });
  if (all) params.set('all', 'true');
  const response = await api.executeGetRequest(`${url}?${params.toString()}`);

  return response.data;
}
